import React, { Component } from "react";
/*
 * 
 */
class ButtonMostrarEdicion extends Component {
    constructor(props) {
        super(props);
    }
    /**
     * 
     */
    render() {
        const { novedad, tarjeta, puedeEjecutar } = this.props;
        let componente = null;
        //let puedeEjecutar = false;

        /*si existe una novedad que fue recuperada entonces puede ver los detalles de la tarjeta, de lo contrario tiene que revisar 
        las demas validaciones DEPRECADO v0*/
        //if (novedad.novedadBaja == undefined && novedad.novedadRecuperada) {
        //    puedeEjecutar = true;
        //} else {
        //    puedeEjecutar = (novedad.novedadBaja == undefined
        //        && novedad.novedadBloqueda == undefined
        //        && novedad.validacionBaja == false
        //        && novedad.validacionBloqueo == false)
        //}

        if (puedeEjecutar == false) {
            componente = (
                <a className="none-text-decoration ti-angle-double-down disabled"></a>
            );
        } else {
            componente = (
                <a className={"clickable none-text-decoration ti-angle-double-" + ((this.props.filaEnModoEdicion) ? "up" : "down")}
                    onClick={this.props.mostrarFilaEnModoEdicion}></a>
            );
        }

        return componente;
    }
}

export default ButtonMostrarEdicion;